<template>
  <div class="modal fade show" :id="modalId" tabindex="-1" aria-labelledby="confirmationModalLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="asyncTasksLabel">
            Configuracion de descarga.
            <span @click="showLimitInfo = !showLimitInfo">
              <i class="fal fa-info-circle"></i>
            </span>
          </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal(false)">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <!-- Formulario -->
        <div class="modal-body">
          <div
            v-show="showLimitInfo"
            class="info-limit-datafeed alert alert-info alert-dismissible"
            role="alert">
            <button type="button" class="close" @click="showLimitInfo = !showLimitInfo">
              <span aria-hidden="true">&times;</span>
            </button>
            <p>
              <i class="fas fa-exclamation-square"></i>
              El límite máximo de tareas para descargar es de <span class="font-weight-bold">{{ maxLimitFillsString }}</span> por descarga.
            </p>
            <p v-if="attachmentSelectionAvailable">
              Para la descarga de Fotos, PDF, Audios, etc. el limite es de <span class="font-weight-bold">{{ maxLimitFillsWithAttachmentsString }}</span> tareas.
            </p>
          </div>
          <div
            v-show="maxLimitFillsOverpass || maxLimitFillsWithAttachmentsOverpass"
            class="info-limit-datafeed alert alert-danger alert-dismissible"
            role="alert">
            <p class="font-weight-bold"><i class="fas fa-exclamation"></i> Limite de tareas superado.</p>
            <p v-if="maxLimitFillsOverpass && !maxLimitFillsWithAttachmentsOverpass">
              La búsqueda realizada superaría los <span class="font-weight-bold">{{ maxLimitFillsString }}</span> registros permitidos para descargar.
              Realice una búsqueda con menos registros.
            </p>
            <p v-else-if="maxLimitFillsWithAttachmentsOverpass">
              La búsqueda realizada superaría los <span class="font-weight-bold">{{ maxLimitFillsWithAttachmentsString }}</span> registros permitidos para descargar las fotografias, PDF, Audios, etc.
              Realice una busqueda con menos registros.
            </p>
          </div>
          <div v-if="!hasFills" class="alert alert-warning" role="alert">
            <i class="fas fa-exclamation-triangle"></i> Lo sentimos, con la consulta actual no hay registros para descargar.
          </div>
          <div v-if="existTaskInProcess" class="alert alert-warning" role="alert">
            <i class="fas fa-exclamation-triangle"></i>
              Actualmente, se tiene una descarga en proceso.
              Para poder generar una nueva, debe esperar a que esta tenga un estado: <em>Terminada, Cancelada o Con error</em>.
          </div>
          <form>
            <!-- Formato de descarga -->
            <div class="form-group">
              <label for="inputFormat">Formato de descarga *</label>
              <select class="form-control" name="inputFormat" id="inputFormat" v-model="form.process.format" :disabled="!hasFills">
                <option v-for="(format, index) in formats" :key="index" :value="format">
                  {{ format }}
                </option>
              </select>
            </div>
            <!-- Advance Options -->
            <div class="form-advance-options">
              <div class="form-advance-options__title p-3" @click="advanceOptionsOpen = !advanceOptionsOpen">
                <h6>
                  Opciones avanzadas
                  <i v-show="!advanceOptionsOpen" class="far fa-angle-down"></i>
                  <i v-show="advanceOptionsOpen" class="far fa-angle-up"></i>
                </h6>
              </div>
              <div class="form-advance-options__config pl-3 pr-3" v-show="advanceOptionsOpen" :class="{ open: advanceOptionsOpen }">
                <!-- Búsqueda -->
                <div class="form-group">
                  <label for="inputSeach">Búsqueda</label>
                  <div class="input-group" aria-describedby="searchFeedback">
                    <select class="form-control" v-model="form.process.search"
                      :disabled="!hasFills || !selectableSearches.length"
                      @change="emitUpdateSearch(form.process.search)">
                      <option selected disabled :value="UNDEFINED_ENTITY_ID" >{{ !selectableSearches.length ? 'No hay búsquedas para seleccionar' : '-- Seleccionar búsqueda --' }}</option>
                      <option v-for="search in selectableSearches" :key="search.id"
                        :value="search.id">{{ search.name }}</option>
                    </select>
                  </div>
                </div>
                <!-- Nombre -->
                <div class="form-group">
                  <label for="name">Nombre</label>
                  <input type="text" class="form-control" id="name"
                    :disabled="!hasFills"
                    :title="form.name"
                    aria-describedby="nameHelp"
                    v-model="form.name"
                    placeholder="Nombre de la descarga. Ej: Descarga_del_mes"
                  />
                  <small id="nameHelp" class="form-text text-muted">Tipo: Mis Tareas</small>
                </div>
                <!-- Attachments -->
                <AttachmentsSelection
                  v-if="attachmentSelectionAvailable"
                  :attachmentColumns="attachmentColumns"
                  :readOnly="!hasFills"
                  :resetComponent="clearAttachmentComponent"
                  :variableFillsIdent="variablesFillsIdent"
                  @update-attachments="updateAttachmentIds"
                  @update-attachments-format="updateAttachmentFormat"
                  @component-restarted="clearAttachmentComponent = false"
                >
                </AttachmentsSelection>
                <!-- Header -->
                <div class="form-group">
                  <label for="inputHeader">Encabezado</label>
                  <div class="input-group" aria-describedby="headerFeedback">
                    <select class="form-control"
                      v-model="form.process.header"
                      :disabled="!hasFills"
                    >
                      <option v-for="(header, index) in headers" :key="index"
                        :value="header">{{ AsyncTaskProcess.getHeaderTranslate(header) }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer pl-3 pr-3">
          <a class="btn btn-outline-secondary w-50 m-0" data-dismiss="modal"
            @click="closeModal(false)">
            Cancelar
          </a>
          <a class="btn btn-primary w-50 m-0"
            :class="{ disabled: blockDownloadButton }"
            @click="manageCreateAsyncTask">
            Descargar
          </a>
          <!-- ALERT ERROR -->
          <div v-if="taskCreated === false" class="alert alert-danger alert-dismissible  w-100 ml-0 mr-0 fade" :class="{ show: taskCreated === false }" role="alert">
            <strong>Error al crear la tarea</strong><br>
            {{ taskError }}
            <button type="button" class="close" aria-label="Close" @click="closeTaskError">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div v-if="searchCreated === false" class="alert alert-danger alert-dismissible  w-100 ml-0 mr-0 fade" :class="{ show: searchCreated === false }" role="alert">
            <strong>Error durante la creación de la búsqueda</strong><br>
            {{ searchError }}
            <button type="button" class="close" aria-label="Close" @click="closeSearchError">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <loading-mask :active="loading"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { AsyncTask, AsyncTaskFormat, AsyncTaskProcess, AsyncTaskStatus, AsynTaskHeaders } from '@/types/catalogs/AsyncTask'
import { APIErrorFormat } from '@/types/Errors'
import Vue, { PropType } from 'vue'
import { CustomSearch, SearchOrigin } from '@/types/catalogs/CustomSearch'
import CatalogsFillsService from '@/services/CatalogsFillsService'
import { FillgridFilters } from '@/types/Fillgrid'
import { UNDEFINED_ENTITY_ID } from '@/types/Catalogs'
import { NUMBER, STRING } from '@/types/GeneralConstants'
import LoadingMask from '@/components/generic/LoadingMask.vue'
import { AttachmentObject, AttachmentFormat, VariableFill } from '@/types/catalogs/Attachment'

export default Vue.extend({
  components: {
    LoadingMask,
    AttachmentsSelection: () => import('@/components/generic/AttachmentsSelection.vue')
  },
  data () {
    return {
      FILLS_MAX_LIMIT: 100000,
      FILLS_WITH_ATTACHMENTS_MAX_LIMIT: 20000,
      UNDEFINED_ENTITY_ID: UNDEFINED_ENTITY_ID,
      AsyncTaskProcess: AsyncTaskProcess,
      formats: Object.values(AsyncTaskFormat).filter(format => ['CSV', 'TSV'].includes(format)),
      headers: Object.values(AsynTaskHeaders),
      searchValues: {} as CustomSearch,
      searchCreated: undefined as undefined | boolean,
      advanceOptionsOpen: false,
      PAGE_SEARCHES_SIZE: 100,
      form: AsyncTask.getInstance() as AsyncTask,
      taskCreated: undefined as undefined | boolean,
      taskError: '',
      attachmentIds: [] as String[],
      loading: false as boolean,
      showLimitInfo: false as boolean,
      showOverpassLimitInfo: false as boolean,
      clearAttachmentComponent: false as boolean
    }
  },
  props: {
    userId: {
      type: Number,
      required: true
    },
    totalFills: {
      type: Number,
      default: NUMBER.ZERO
    },
    modalId: {
      type: String,
      default: 'downloadFillsModal'
    },
    templateId: {
      type: Number,
      required: true
    },
    templateName: {
      type: String,
      required: true
    },
    searchIdSelected: {
      type: Number,
      required: true
    },
    searches: {
      type: [] as PropType<CustomSearch[]>,
      required: true
    },
    filters: {
      type: Object,
      required: true
    },
    creatingSearch: {
      required: true
    },
    searchError: {
      type: String
    },
    existTaskInProcess: {
      type: Boolean,
      default: false
    },
    attachmentColumns: {
      type: [] as PropType<Array<AttachmentObject>>,
      required: true
    },
    permissionToSelectAttahments: {
      type: Boolean,
      default: false
    },
    variablesFillsIdent: {
      type: [] as PropType<Array<VariableFill>>,
      required: true
    }
  },
  mounted () {
    this.initForm()
  },
  computed: {
    isSearchIdSelected (): boolean {
      return this.searchIdSelected > 0
    },
    isThereSearch (): boolean {
      let process = this.form.process
      return process && process.search !== undefined && process.search > 0
    },
    selectableSearches (): CustomSearch[] {
      return this.searches.filter((search) => search.origin === SearchOrigin.FILLGRID)
    },
    attachmentSelectionAvailable (): boolean {
      return this.permissionToSelectAttahments && this.attachmentColumns.length > 0
    },
    hasFills () {
      return this.totalFills > 0
    },
    maxLimitFillsOverpass () {
      return this.totalFills > this.FILLS_MAX_LIMIT
    },
    maxLimitFillsWithAttachmentsOverpass () {
      return this.totalFills * (this.form.process?.attachmentIds?.length || 0) > this.FILLS_WITH_ATTACHMENTS_MAX_LIMIT
    },
    maxLimitFillsString () {
      return this.FILLS_MAX_LIMIT.toLocaleString()
    },
    maxLimitFillsWithAttachmentsString () {
      return this.FILLS_WITH_ATTACHMENTS_MAX_LIMIT.toLocaleString()
    },
    blockDownloadButton () {
      return (this.totalFills <= 0) ||
        this.existTaskInProcess ||
        this.loading ||
        this.totalFills > this.FILLS_MAX_LIMIT ||
        this.totalFills * (this.attachmentIds.length || 0) > this.FILLS_WITH_ATTACHMENTS_MAX_LIMIT
    }
  },
  watch: {
    /**
     * Listen to the change in searchIdSelected
     * @param currentSearchId
     * @param oldSearchId
     */
    searchIdSelected (currentSearchId: number, oldSearchId: number) {
      this.setFormSearchId(currentSearchId)
    },
    /**
     * Listen to the change in the searchId into the form object
     *
     * @param currentSearchId current value
     * @param oldSearchId old value
     */
    'form.process.search' (currentSearchId: any, oldSearchId: any) {
      if (!this.form.name) {
        if (currentSearchId === UNDEFINED_ENTITY_ID) this.setTaskName(STRING.EMPTY_STRING)
        else this.proposalTaskNameFromSearches(this.searchIdSelected)
      }
    },
    /**
     * Listen to change the creatingSearch
     * This is used when create a new search from the creation of a new async task
     *
     * @param stillWaiting
     * @param wasWaiting
     */
    creatingSearch (stillWaiting: boolean, wasWaiting: boolean) {
      // If we were waiting and currently no more
      // and we received a value form in the searchId value for the form
      // we try to create the async task, if we were waiting but we
      // didn't receive a searchId value is because its creation failed.
      if (wasWaiting && !stillWaiting && this.isThereSearch) {
        this.createAsyncTask(true)
      } else if (wasWaiting && !stillWaiting && !this.isThereSearch) {
        this.setSearchCreated(false)
      }
    }
  },
  methods: {
    /** Initialize form values */
    initForm (): void {
      this.form.template.id = this.templateId
      this.form.template.name = this.templateName
      this.form.template.label = this.templateName
    },
    /**
     * @param id of the search to set
     */
    setFormSearchId (id: number) {
      this.form.process.search = id
    },
    /** Set a default name for a new search */
    initSearchName () {
      return `Búsqueda_${this.todayFormat()}`
    },
    /**
     * After emits the event for create a new seach with name 'searchName'
     * waits until the form receive a search id or not but the attempt
     * to create the search has finished.
     *
     * @param searchName name for the search to create
     */
    createSearch (searchName: string) {
      const filters = Object.assign({}, this.filters) as FillgridFilters
      filters.name = searchName
      filters.origin = SearchOrigin.DATAFEED // all searches created from this component will be of type DATAFEED
      this.emitCreateSearch(filters)
      this.emitWaitingSearch(true)
    },
    /**
     * Emit the event to update the current searchIdSelected
     * @param searchId id selected
     */
    emitUpdateSearch (searchId?: number) {
      this.$emit('update-search', searchId)
    },
    /**
     * Emit the event to try to create a new search
     * @param filters to create a new search
     */
    emitCreateSearch (filters: FillgridFilters) {
      this.$emit('create-search', filters)
    },
    /**
     * Emit the event to indicate we are waiting for the creation of a new search
     * @param creating flag
     */
    emitWaitingSearch (creating: boolean) {
      this.$emit('waiting-search', creating)
    },
    /**
     * Manage the case to create a new task async
     * When hasn't been selected an already search created,
     * we emit the event to create one and wait for the response,
     * otherwise we create directly a new async task
     */
    manageCreateAsyncTask () {
      this.$emit('check-view-changes')
      if (!this.isThereSearch) {
        const defaultSearchName = this.initSearchName()
        if (!this.form.name) this.proposalTaskName(defaultSearchName)
        this.createSearch(defaultSearchName)
      } else {
        this.createAsyncTask()
      }
    },
    /**
     * Create a new async task to get the current fills
     *
     * @param clearSearch flag to clear the search values settled
     */
    async createAsyncTask (clearSearch: boolean = false) {
      if (this.loading) return
      this.loading = true
      await CatalogsFillsService.createAsyncTask(this.form)
        .then((response) => {
          this.$store.commit(
            'taskNotifications/addTask',
            {
              taskState: AsyncTaskStatus.PROCESSING,
              task: { id: response.id, type: response.type, updateDate: response.updateDate }
            }
          )
          this.showDatafeedToast('Descarga iniciada', response.id, response.template.name, response.updateDate, response.process.requestId)
          this.clearAttachmentComponent = true
          this.closeModal(true)
        })
        .catch((error) => {
          this.setTaskCreated(false)
          let errorData = Object.assign(new APIErrorFormat(), error.response.data)
          if (errorData.isNewErrorFormat()) {
            let blueErrors = errorData.errors
            if (blueErrors.length > 0 && blueErrors[0].code) {
              this.taskError = blueErrors[0].description
            } else {
              this.taskError = blueErrors[0].description
            }
          } else {
            this.taskError = error.response.data.message
          }
        })
        .finally(() => {
          if (clearSearch) {
            this.setFormSearchId(UNDEFINED_ENTITY_ID)
            this.emitUpdateSearch(UNDEFINED_ENTITY_ID)
          }
          this.loading = false
        })
    },
    showDatafeedToast (title: string, id: number, template: string, date: string, requestId: string) {
      const dateOpts: Intl.DateTimeFormatOptions = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }
      const dateFormat = Intl.DateTimeFormat('es-MX', dateOpts).format(new Date(`${date}Z`))
      const h = this.$createElement
      const node = h(
        'div', { class: ['d-flex', 'flex-column', 'p-0'] }, [
          h('p', { class: 'm-0' }, [
            h('span', { class: ['font-weight-bold', 'mr-1'] }, `ID:`), `${id}`
          ]),
          h('p', { class: 'm-0' }, [
            h('span', { class: ['font-weight-bold', 'mr-1'] }, `Template:`), template
          ]),
          h('p', { class: 'm-0' }, [
            h('span', { class: ['font-weight-bold', 'mr-1'] }, `Fecha:`), dateFormat
          ]),
          h('p', { class: 'text small m-0' }, [
            h('span', { class: ['font-weight-bold', 'mr-1'] }, `Request:`), requestId
          ])
        ])
      this.$bvToast.toast([node], {
        title: `${title}. [Mis Tareas]`,
        variant: 'success',
        autoHideDelay: 7500,
        solid: true
      })
    },
    /**
     * Emit the close modal event and delete the modal-backdrop,
     * finally reset the form values for the next async task
    */
    closeModal (resetForm?: boolean) {
      this.$emit('close')
      let backdropModal = document.getElementsByClassName('modal-backdrop fade show')[0]
      if (backdropModal) {
        backdropModal.remove()
      }
      this.resetForm(resetForm)
    },
    /** Close the message error in case exist one when we try to create an async task */
    closeTaskError () {
      this.setTaskCreated(undefined)
      this.taskError = ''
    },
    /** Close the message error in case exist one when we try to create a custom search */
    closeSearchError () {
      this.setSearchCreated(undefined)
    },
    /** Clear the form values for the next task */
    resetForm (clearForm?: boolean) {
      if (clearForm) {
        const previousSearchId = this.form.process.search
        const lastTaskName = this.form.name
        this.form = AsyncTask.getInstance()
        this.initForm()
        this.form.process.search = previousSearchId
        const genericSearchNameRegExp = /Búsqueda_\d{8}-\d{6}/i
        if (genericSearchNameRegExp.test(lastTaskName)) {
          this.setTaskName(STRING.EMPTY_STRING)
        } else {
          this.proposalTaskNameFromSearches(this.searchIdSelected)
        }
      }
      this.advanceOptionsOpen = false
      this.setTaskCreated(undefined)
      this.resetCurrentSearchValues()
    },
    /** Clear the values for the new search based on the current search */
    resetCurrentSearchValues () {
      this.setSearchCreated(undefined)
    },
    /**
     * Get the search name from the searches of the user
     *
     * @param searchId to get the search name
     */
    getSearchName (searchId: number) : string {
      let searchName
      if (searchId > 0 && this.searches.length) {
        let searchIndex = this.searches.findIndex((search: CustomSearch) => search.id === searchId)
        searchName = searchIndex > -1 ? this.searches[searchIndex].name : ''
      }
      return searchName || this.searchValues.name
    },
    /**
     * Assign the name to the new async task
     *
     * @param name string to assign
     */
    setTaskName (name: string) : void {
      this.form.name = name
    },
    /**
     * Create and assign a proposal task name
     *  <template_name>_<search_name>_<ddmmyyyy-hhmmss>
     *
     * @param searchId to get its name
     */
    proposalTaskNameFromSearches (searchId?: number): void {
      if (searchId && searchId > 0) {
        this.proposalTaskName(`${this.getSearchName(searchId)}`)
      } else {
        this.proposalTaskName(`${this.searchValues.name}`)
      }
    },
    /**
     * Assign the async task name with the form
     *  <template_name>_<search_name>_<ddmmyyyy-hhmmss>
     *
     * @param searchName proposal name to new task
     */
    proposalTaskName (searchName: string) : void {
      this.setTaskName(`${this.templateName}__${searchName}`)
    },
    /** Create a date format to use into the proposal task name */
    todayFormat (): string {
      let todayDate = new Date()
      let day = todayDate.getDate().toString().padStart(2, '0')
      let month = todayDate.getMonth().toString().padStart(2, '0')
      let year = todayDate.getFullYear()
      let hour = todayDate.getHours().toString().padStart(2, '0')
      let minutes = todayDate.getMinutes().toString().padStart(2, '0')
      let sec = todayDate.getSeconds().toString().padStart(2, '0')
      return `${day}${month}${year}-${hour}${minutes}${sec}`
    },
    setSearchCreated (value: undefined | boolean) {
      this.searchCreated = value
    },
    setTaskCreated (value: undefined | boolean) {
      this.taskCreated = value
    },
    updateAttachmentIds (ids: string[]): void {
      this.attachmentIds = ids
      this.form.process.attachmentIds = ids
    },
    updateAttachmentFormat (formats: AttachmentFormat): void {
      this.form.process.attachmentFormat = formats
    }
  }
})
</script>

<style lang="scss" scoped>
.modal {
  display: none;
  position: fixed;
  z-index: 1050;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0,0,0);
  background-color: rgba(0,0,0,0.4);

  .modal-content {
    margin: 2rem auto;
    padding: 0.5rem;
  }
}
.info-limit-datafeed {
  p {
    margin: 0;
  }
}
.form-advance-options {
  border-radius: 4px;
  background-color: var(--sidebar-bg-color);

  .form-advance-options__title {
    border-radius: 4px;
    padding: 0.5rem;
    width: 100%;

    &:hover {
      background-color: var(--element-hover-bg-color);
    }

    h6 {
      margin: 0;
      user-select: none;
    }

    i {
      float: right;
    }
  }
  .form-advance-options__config {
    padding: 0.5rem;
  }
}
</style>
